<div class="col-12 col-md-12" style="padding: 3.4vh;">
  <div class="row mt-2" style="width: 100%;">
    <div class="col-6 col-md-6 border" style="padding: 2vh;">
      <div class="local-setting">
        <div class="widget-container fluid-height ">
          <div class="heading">
            <i class="fa fa-save"></i>&nbsp;
            <span class="text-heading">{{"Local Settings" | translate}}</span>
          </div>
          <div class="widget-content padded mt-4">
            <button (click)="resetSettings(alert_message)" class="btn btn-danger">
              <i class="fa fa-trash-o"></i>&nbsp;
              <span>{{"Reset Settings" | translate}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-6 border" style="padding: 2vh;">
      <div class="language">
        <div class="widget-container fluid-height ">
          <div class="heading">
            <i class="fa fa-flag"></i>&nbsp;
            <span class="text-heading">{{"Language"  | translate}}</span>
          </div>
          <div class="widget-content padded mt-4">
            <div class="form-horizontal">
              <div class="form-group">
                <select id="languageSelect"
                  class="form-control"
                  (change)="selectLanguage($event)"
                  style="width: 40%;">
                  @for (lang of LangOptions; track lang) {
                    <option [value]="lang.value">
                    {{ lang.label }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- date format  -->
    <!-- <div class="col-md-3 border" style="padding: 2vh;">
    <div class="date-format">
      <div class="widget-container fluid-height">
        <div class="heading">
          <i class="fa fa-clock-o"></i>&nbsp;
          <span class="text-heading">{{"Date Format" | translate}}</span>
        </div>
        <div class="widget-content padded mt-4">
          <div class="form-horizontal">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text" title="Define your own Date format"><span class="fa fa-clock-o mb-2"></span></div>
                </div>
                <input type="text" class="form-control" [(ngModel)]="dateFormat" (blur)="updateDateFormat()" placeholder="MM/DD/YY hh:mm:ss">
              </div>
              <small class="date-format-error text-danger"></small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Email separator  -->
  <!-- <div class="col-md-3 border" style="padding: 2vh;">
  <div class="email-separator">
    <div class="widget-container fluid-height ">
      <div class="heading">
        <i class="fa fa-envelope-o"></i>&nbsp;
        <span class="text-heading">{{"Email address separator" | translate}}</span>
      </div>
      <div class="widget-content padded mt-4">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" title="Define your own Email address separator"><span class="fa fa-envelope-o mb-2"></span></div>
              </div>
              <input type="text" class="form-control" size="2"  [(ngModel)]="emailAddressSeparator" (blur)="updateEmailSeperator()">
            </div>
            <small class="email-separator-error text-danger"></small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
</div>
</div>


<ng-template #alert_message let-modal>
  <div class="modal-body text-center">
    <p class="action-message">{{alertMessage}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>